import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  AgrPageToolbarModule,
  AgrLogoWideModule,
  AgrPrintPageModule,
  AgrPageDetailModule,
  AgrFilterModule,
  AgrNotificationEmptyModule,
  AgrValueRowModule,
} from '@next/core-lib/components';
import { AgrDialogModule } from '@next/core-lib/dialog';

 
import { AgrFormModule } from '@next/core-lib/form';
import { LetDirective, PushPipe } from '@ngrx/component';

import { CustomerProductInventoryDialogComponent } from './components/customer-product-inventory-dialog/customer-product-inventory-dialog.component';

 
import { CustomerProductInventoryPrintComponent } from './components/customer-product-inventory-print/customer-product-inventory-print.component';
import { LinkCropfieldDialogComponent } from './components/link-cropfield-dialog/link-cropfield-dialog.component';
import { OrderLineDialogComponent } from './components/order-line-dialog/order-line-dialog.component';

import { ReportComponent } from './components/report/report.component';
import { SwitchTranslationPipe } from './pipes/switch-translation.pipe';
import { ReportsModule } from '../reports/reports.module';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    SwitchTranslationPipe,
    OrderLineDialogComponent,
    CustomerProductInventoryDialogComponent,
    ReportComponent,
    CustomerProductInventoryPrintComponent,
    LinkCropfieldDialogComponent,
  ],
  imports: [
    SharedModule,
    AgrPageToolbarModule,
    FormsModule,
    ReactiveFormsModule,
    LetDirective, PushPipe,
    AgrDialogModule,
    AgrFormModule,
    AgrPrintPageModule,
    MatListModule,
    MatIconModule,
    MatDividerModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatInputModule,
    MatTableModule,
    MatExpansionModule,
    MatCheckboxModule,
    AgrLogoWideModule,
    AgrPageDetailModule,
    AgrFilterModule,
    MatTooltipModule,
    MatToolbarModule,
    AgrNotificationEmptyModule,
    AgrValueRowModule,
    ReportsModule,
  ],
})
export class OverviewModule {}
